module.exports = __webpack_public_path__ + "resources/img/logo_toast_gov.8520bbd22161a8a0d5b0ca29d493dc15.png";